import { z } from '@hono/zod-openapi'
import { zSelectSignupAccessControl } from './signup-access-control.zod'

export const zCreateBulkSignupAccessControl = z.object({
    clientId: z.string({ error: 'ClientId is required' }),
    emails: z.email().array().min(1, {
        message: 'Email is required',
    }),
    isBlocked: z.boolean().default(false),
})

export const zSignupAccessControlBulkCreateSuccessResponse = z.array(
    zSelectSignupAccessControl,
)

export const zSignupAccessControlBulkCreateConflictResponse = z.object({
    existingEmails: z
        .object({
            allowed: z.email().array(),
            blocked: z.email().array(),
        })
        .optional(),
    invalidDomains: z
        .object({
            emails: z.email().array(),
            acceptedDomains: z.string().array(),
        })
        .optional(),
})

export const zSignupAccessControlCountsResponse = z.object({
    allowed: z.number(),
    blocked: z.number(),
    isActivateBlockList: z.boolean(),
})

export type CreateBulkSignupAccessControl = z.infer<
    typeof zCreateBulkSignupAccessControl
>
